import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { MotifFormsModule, MotifIconModule } from '@ey-xd/ng-motif';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { ICellEditorParams } from 'ag-grid-community';
import { MotifContentIcSave24px } from '@ey-xd/motif-icon';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

export interface AssetCellEditorParams extends ICellEditorParams {
  assets?: any[];
  isDisabled?: boolean;
}

@Component({
  selector: 'app-asset-class-cell-editor',
  standalone: true,
  imports: [MotifFormsModule, MotifIconModule, CommonModule, FormsModule],
  templateUrl: './asset-class-cell-editor.component.html',
  styleUrl: './asset-class-cell-editor.component.scss',
})
export class AssetClassCellEditorComponent
  implements ICellEditorAngularComp, AfterViewInit
{
  private params!: ICellEditorParams;
  private value!: string;
  public assets: string[] = [];
  selectedAsset: string = '';
  public isDisabled: boolean = false;

  // icons
  saveIcon = MotifContentIcSave24px;

  ngAfterViewInit(): void {}

  constructor() {}

  agInit(params: AssetCellEditorParams): void {
    this.params = params;
    this.value = params.value;
    this.selectedAsset = this.value;
    this.assets = params.assets || [];
    this.isDisabled = params.isDisabled === true;
  }

  getValue() {
    return this.value;
  }

  isPopup?(): boolean {
    return false;
  }

  isCancelBeforeStart?(): boolean {
    return false;
  }

  isCancelAfterEnd?(): boolean {
    return false;
  }

  onValueChange(value: any): void {
    this.value = value;
    this.save();
  }
  save(): void {
    this.params.api.stopEditing();
  }
}
